import React from 'react';
import Typography from '@/components/ui/typography';

const ProcessingIndicator: React.FC = () => {
  return (
    <div className="flex items-center gap-3">
      <div className="animate-spin rounded-full h-5 w-5 border-2 border-[#5536F5] border-t-transparent"></div>
      <Typography
        variant="p"
        color="neutral700"
        weight="medium"
        size="14"
        className="text-[#5536F5]"
      >
        Processing...
      </Typography>
    </div>
  );
};

export default ProcessingIndicator;
